module.exports = __webpack_public_path__ + "img/salta-fila.30af9936.png";